import {FieldValues} from 'react-hook-form';
import Title from '@/components/help/common/Title';
import ReportNotice from '@/components/help/pc/report/ReportNotice';
import {FormGroup} from '@/components/help/common/FormContainer';
import {REPORT_FIELD_ORDER, FORM_TYPE_REPORT} from '@/constants/help/index';
import {useFormDefaultFieldValues} from '@/hooks/help/useFormDefaultValues';
import {useSubmitForm} from '@/hooks/help/useSubmitForm';

// 신고하기 페이지
const HelpReportContent = () => {
  const defaultFieldValues = useFormDefaultFieldValues({
    type: FORM_TYPE_REPORT,
  });

  const {mutate: postHelpForm} = useSubmitForm({type: FORM_TYPE_REPORT});

  const onSubmit = (data: FieldValues) => {
    postHelpForm(data);
  };

  return (
    <>
      <Title title='신고하기' />
      <ReportNotice />
      <FormGroup
        onSubmit={onSubmit}
        fieldOrder={REPORT_FIELD_ORDER}
        defaultValues={defaultFieldValues}
        type={FORM_TYPE_REPORT}>
        <FormGroup.UserId />
        <FormGroup.OsInfo />
        <FormGroup.Email />
        <FormGroup.Category showDetailType={false} />
        <FormGroup.Title />
        <FormGroup.Content />
        <FormGroup.AttachedFiles />
        <FormGroup.CautionBox />
        <FormGroup.Agreement />
        <FormGroup.ActionButtons />
      </FormGroup>
    </>
  );
};

export default HelpReportContent;
